import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import authUser from './auth/reducer';
import notificatoins from './notifications/reducer';


const reducers = combineReducers({
  menu,
  settings,
  notificatoins,
  authUser
});

export default reducers;